import MathRenderer from "../components/taskUser copy 3.js"
import React, { Component } from 'react';
import Markdownkatexnew from "./Markdown.js";
import Navigation from '../screens/Navigation.jsx';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify'
import { Link } from 'react-router-dom';
import axios from 'axios'
import WindowFocusHandler from "./isvisible.js";
import Select, { components } from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
// import Blog from "../components/taskUser copy 2.js";
import Socket from "../screens/Chat.jsx";
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, Toolbar } from 'ckeditor5';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Math from 'ckeditor5-math/src/math';
// import TimeAgo from 'timeago-react';
import Timer from './timer.js';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import 'katex/dist/katex.min.css'; // Don't forget the KaTeX stylesheet
import { registerLocale } from "react-datepicker";
import { parseISO } from "date-fns";
import wes from 'date-fns/locale/es';
import { isAuth } from "../helpers/auth.js";
registerLocale('es', wes);
timeago.register('es', es);

export default class Tests extends Component {

  constructor(props) {
    super(props);
    this.state = {
      solution: "",
      contenido: "",
      task: "",
      detail: '<p>www www</p><p><span class="math-tex">\\(www\\)</span></p>',
      themeall: "",
      fechaexa: new Date(),
      timexa: "2",
      editing: false,
      integers: [],
      items: [],
      theme: "",
      dateb: new Date(),
      datee: "",
      note: "",
      setLoading: false,
      one: 3,
      noww: "",
      _idcurse: "",
      submit: "",
    }
  };

  getNotes = async () => {
    // console.log(this.props.match.params.idtest)
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      console.log(res.data, "www");
      if (res.data && res.data.length != 0) {
        this.setState({
          dateb: parseISO(res.data.dateb),
          datee: parseISO(res.data.datee),
          theme: res.data,
          idcurse: res.curse,
          items: res.data.items,
          solution: res.data.solution,
          task: res.data.task == '' ? 'www' : res.data.task.replace(new RegExp('<span class="math-tex">\(\)</span>', 'g'), '').replace(new RegExp('<span class="math-tex">\[\]</span>', 'g'), ''),
          note: res.data.note,
        });
      } else {
        // history.push("/categorias");
      }
    });
  }

  getNotesNotes = async () => {
    await axios.get(
      `${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`
    ).then(res => {
      this.setState({
        theme: res.data[0],
      });
      console.log(res.data[0]);
      console.log(this.state.theme.task, this.state.theme.note);
    });
  }

  submitTest = async (items, note) => {
    const Data = {
      task: this.state.task,
      solution: this.state.solution,
      items: items,
      note: note
    };
    // console.log(Data)
    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${this.props.match.params.idtest}`, Data).then(res => {
      toast.dark(res.data)
      this.getNotes()
    });
  };

  culminarTest = () => {
    var encuestas = this.state.items
    var rptas = []
    for (var j = 0; j < encuestas.length; j++) {
      if (encuestas[j].alt) {
      } else {
        // this.ollama(encuestas[j].std, encuestas[j].prg, this.props.match.params.idtest)
        // console.log(encuestas[j].std, this.props.match.params.idtest)
      }
    }
  }

  async componentDidMount() {
    await this.getNotes()
  }


  onChange = (text) => (e) => {
    // console.log(e.label[0], e.value[0], text)
    // console.log(e.label[0], text);
    var www = this.state.items
    www[text].std = e.label[0]
    this.setState({
      items: www
    })
    var rptas = []
    for (var j = 0; j < www.length; j++) {
      if (www[j].std === www[j].rpta) {
        rptas.push(1)
      } else {
        rptas.push(0)
      }
    }
    this.setState({ note: rptas.filter(x => x === 1).length })

    console.log(rptas.filter(x => x === 1).length)
    if (www != null) { this.submitTest(www, rptas.filter(x => x === 1).length) }
    // this.submitTest()
  }

  onChangeText = (text, i) => {
    // console.log(text, i);
    var www = this.state.items
    www[i].std = text
    this.setState({
      items: www
    })
    console.log(www)
    if (www != null) { this.submitTest(www, this.state.note) }
    // this.submitTest()
  }

  MarkdownOption = (props) => {
    // console.log(props.data.label[0])
    return (
      <components.Option {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.Option>
    );
  };

  MarkdownSingleValue = (props) => {
    // console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.SingleValue>
    );
  };

  ollama = async (prompt, pregunta, idtest) => {
    // e.preventDefault();
    console.log(prompt, idtest)
    // if (!input.trim()) return;

    this.setState({ setLoading: true });
    // setResponse('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/userReduce`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: `Calficar de 0 a 1 la siguiente respuesta ${prompt} a la pregunta ${pregunta}`,
          model: "llama3" //gemma4  Change this to your local model name
        }),
      });

      const data = await res.json();
      if (data.response) {
        console.log(data.response);
      } else {
        console.log('Error: No hay respuesta recibida.');
      }
    } catch (err) {
      console.log('Error al conectar con el backend server.');
    } finally {
      this.setState({ setLoading: false });
    }
  };


  safeJsonParse(str, fallback = null) {
    try {
      return JSON.stringify(str);
    } catch {
      return fallback;
    }
  }

  handleDataFromChild = (data) => {
    // WindowFocusHandler
    // history.push(`/curso/${this.state._idcurse}`)
    console.log(this.state._idcurse)
    this.setState({ setLoading: true });
  };

  handleFromChild = (data) => {
    // setSecondsRemaining(0)
    console.log(data)
    // this.props.history.push(`/curso/${this.props.match.params.theme}`)
    // setShow(false);
  };


  render() {
    return (
      <div className=''>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Navigation />

        {/* <WindowFocusHandler onDataReceived={this.handleDataFromChild} /> */}
        <Timer endDate={this.state.datee} onFinish={this.handleFromChild} />

        <div className='container'>

          {/* <Blog /> */}

          {isAuth().rol == '1' ?
            <div>
              <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                {this.state.items ? this.state.items.map((number, i) =>
                  <div key={i + 1} className={`${number.alt ? 'col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1' : 'col-sm-12 col-md-12 col-lg-12'}`}>
                    <div className="p-1 bg-light rounded">
                      {/* {number.prg} */}
                      [{i + 1}]
                      <Markdownkatexnew>
                        {number.prg}
                      </Markdownkatexnew>
                      <MathRenderer>
                        {number.std}
                      </MathRenderer>
                      {number.alt ?
                        <div className='marginbottomp'>
                          <Select onChange={this.onChange(i)} options={
                            number.alt.map((guest, index) => {
                              return {
                                label: guest,
                                value: guest,
                                key: index
                              }
                            })
                          } components={{ Option: this.MarkdownOption, SingleValue: this.MarkdownSingleValue }} />
                        </div>
                        :
                        <CKEditor editor={ClassicEditor} config={{
                          // plugins: [Math, /* ... other plugins */],
                          language: 'es', placeholder: "Descripción",
                          toolbar: ["undo", "redo", "|", "math", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"],
                          math: {
                            engine: 'katex', // or 'mathjax'
                            outputType: 'span', // 'span' or 'script'
                            forceOutputType: false,
                            enablePreview: true
                          }
                        }} data={number.std}
                          onBlur={(event, editor) => {
                            this.onChangeText(editor.getData(), i)
                          }} onReady={editor => {
                            // console.log('Editor is ready to use!', editor)
                          }}
                        // name="detail"
                        />
                      }
                    </div>
                  </div>
                ) : ''}
              </div>
              <textarea className="form-control" value={JSON.stringify(this.state.items)} rows={8} onChange={(event) => {
                // console.log(JSON.parse(event.target.value))
                if (JSON.parse(event.target.value)) {
                  this.setState({
                    items: JSON.parse(event.target.value)
                  })
                }
              }}
                required="required"></textarea>
              {this.state.solution.length < 3 ? <input placeholder='Nota' defaultValue={this.state.note} onChange={(event) => {
                this.setState({
                  note: event.target.value
                });
                console.log(event.target.value)
              }} className="form-control mt-3" /> : null}
            </div>
            : null
          }

          {this.state.dateb < this.state.noww && this.state.noww < this.state.datee || JSON.parse(localStorage.getItem("user")).rol == '1' ?
            <>
              <button className="btn btn-info w-100 my-5" onClick={() => { this.submitTest(this.state.items, this.state.note) }} disabled={this.state.setLoading}>
                Guardar
              </button>
              <button className="btn btn-info w-100 my-5" onClick={() => { this.culminarTest() }} disabled={this.state.setLoading}>
                Culminar y calificar
              </button>
            </>
            :
            <div className="bg-warning w-100 p-1 my-5 text-center">Culminó el tiempo establecido
              <Link
                className="btn btn-outline-info w-100"
                style={{ color: 'dark' }}
                to={'/curso/' + this.state.theme.curse}
              >Ir al curso</Link>
            </div>
          }

        </div>
        <Socket />
      </div>
    );
  }
}
